import { render, staticRenderFns } from "./AdditionalService.vue?vue&type=template&id=723bbe45"
import script from "./AdditionalService.vue?vue&type=script&lang=js"
export * from "./AdditionalService.vue?vue&type=script&lang=js"
import style0 from "./AdditionalService.vue?vue&type=style&index=0&id=723bbe45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports